import { Table } from "react-bootstrap";

const ModalRowData = ({ record }) => {
  console.log(record);
  return (
    <Table className="rowdata-subtable" striped bordered hover>
      <thead>
        <tr>
          <th>Caracter</th>
          <th>Observación</th>
          <th>Documentos</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><div>{record?.caracter}</div></td>
          <td><span>{record?.observaciones}</span></td>
          <td><div>
            {record?.documentos?.length ? (
              <ul>
                {record.documentos.map((e, i) => {
                  const pathTo = `${record.inmueble}_${record.recurso}/${e.documento}`;

                  return (
                    <li key={(e.name || e.documento) + i}>
                      {e.id ? (
                        <a
                          href={"https://staticcontent.sannicolasciudad.gob.ar/images/gestion-deudas/" + pathTo}
                          key={"cedula" + i}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {e.documento}
                        </a>
                      ) : (
                        <span>{e.name}</span>
                      )}
                    </li>
                  );
                })}
              </ul>
            ) : ""}
          </div></td>
        </tr>
      </tbody>
    </Table>
  );
};

export default ModalRowData;
